import {
  OPEN_PLATFORM_APP_MARKET_PAGE_REQUEST,
  OPEN_PLATFORM_APP_MARKET_LIST_REQUEST,
  OPEN_PLATFORM_APP_MARKET_SET_APPS,
  OPEN_PLATFORM_APP_MARKET_SET_APP_DETAIL,
  OPEN_PLATFORM_APP_MARKET_ON_CHANGE_FIELD,
  OPEN_PLATFORM_APP_MARKET_ON_CLICK_LEARN_MORE,
  OPEN_PLATFORM_APP_MARKET_SHOW_DETAIL_MODAL,
  OPEN_PLATFORM_APP_MARKET_HIDE_DETAIL_MODAL,
} from './constants';

export function pageRequest({ request }) {
  return { type: OPEN_PLATFORM_APP_MARKET_PAGE_REQUEST, payload: request };
}

export function listRequest({ params }) {
  return { type: OPEN_PLATFORM_APP_MARKET_LIST_REQUEST, payload: { params } };
}

export function onChangeField({ field, value, searchValues }) {
  return {
    type: OPEN_PLATFORM_APP_MARKET_ON_CHANGE_FIELD,
    payload: { field, value, searchValues },
  };
}

export function setApps({ apps }) {
  return { type: OPEN_PLATFORM_APP_MARKET_SET_APPS, payload: { apps } };
}

export function setAppDetail({ app }) {
  return { type: OPEN_PLATFORM_APP_MARKET_SET_APP_DETAIL, payload: { app } };
}

export function onClickLearnMore({ app }) {
  return {
    type: OPEN_PLATFORM_APP_MARKET_ON_CLICK_LEARN_MORE,
    payload: { app },
  };
}

export function showDetailModal() {
  return { type: OPEN_PLATFORM_APP_MARKET_SHOW_DETAIL_MODAL, payload: {} };
}

export function hideDetailModal() {
  return { type: OPEN_PLATFORM_APP_MARKET_HIDE_DETAIL_MODAL, payload: {} };
}
